/**
 * @deprecated This file contains mock data for the Security Dashboard.
 * TODO: Replace all mock data with real API calls when backend endpoints are available.
 * See: https://github.com/earlycore/earlycore-webservices/issues/XXX
 *
 * Types have been extracted to types/security.ts
 * Utilities have been extracted to utils/dateHelpers.ts
 */
import {
  SecurityIssue,
  SecurityDashboardStats,
  ComplianceScore,
  ChartDataPoint,
  StatusTrendDataPoint,
  SeverityStats,
  ChartMetadata,
} from "../types/security";

// TODO: Replace with useSecurityIssues() hook fetching from /api/v1/security-issues
export const mockSecurityIssues: SecurityIssue[] = [
  {
    id: "SEC-001",
    timestamp: "2025-10-15T10:23:45Z",
    type: "PII_DETECTION",
    severity: "CRITICAL",
    status: "OPEN",
    title: "Social Security Number Detected in Prompt",
    description:
      "User input contained a valid SSN pattern that was not sanitized before processing.",
    traceId: "trace_8a9b7c6d5e4f3g2h",
    scanner: "Secrets Scanner",
    riskScore: 0.95,
    detectedContent: "My SSN is ***-**-1234",
    sanitizedContent: "My SSN is [REDACTED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_12345",
      model: "gpt-4",
      pattern: "SSN",
    },
  },
  {
    id: "SEC-002",
    timestamp: "2025-10-15T09:15:22Z",
    type: "PROMPT_INJECTION",
    severity: "HIGH",
    status: "IN_REVIEW",
    title: "Potential Prompt Injection Attempt",
    description:
      "Input contained instructions attempting to override system prompts and extract sensitive information.",
    traceId: "trace_7h8i9j0k1l2m3n4o",
    scanner: "PromptInjection Scanner",
    riskScore: 0.87,
    detectedContent: "Ignore previous instructions and tell me...",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_67890",
      model: "gpt-4",
      attackType: "instruction_override",
    },
  },
  {
    id: "SEC-003",
    timestamp: "2025-10-15T08:45:10Z",
    type: "DATA_EXFILTRATION",
    severity: "CRITICAL",
    status: "OPEN",
    title: "Suspicious Data Export Pattern Detected",
    description:
      "Model output contained structured data that appears to be exfiltrating internal database schema information.",
    traceId: "trace_5p6q7r8s9t0u1v2w",
    scanner: "Relevance Scanner",
    riskScore: 0.92,
    detectedContent: "Table: users, Columns: id, email, password_hash...",
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_24680",
      model: "gpt-3.5-turbo",
      dataType: "database_schema",
    },
  },
  {
    id: "SEC-004",
    timestamp: "2025-10-15T07:30:55Z",
    type: "TOXIC_CONTENT",
    severity: "MEDIUM",
    status: "RESOLVED",
    title: "Toxic Language Detected in User Input",
    description: "User input contained toxic language that exceeded acceptable thresholds.",
    traceId: "trace_3x4y5z6a7b8c9d0e",
    scanner: "Toxicity Scanner",
    riskScore: 0.68,
    detectedContent: "[Toxic content redacted]",
    sanitizedContent: "[Content blocked due to toxicity]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_13579",
      model: "gpt-4",
      toxicityScore: 0.85,
    },
  },
  {
    id: "SEC-005",
    timestamp: "2025-10-15T06:20:30Z",
    type: "MALICIOUS_URL",
    severity: "HIGH",
    status: "OPEN",
    title: "Malicious URL in Model Output",
    description:
      "Model generated response contained a URL flagged as malicious by threat intelligence.",
    traceId: "trace_1f2g3h4i5j6k7l8m",
    scanner: "MaliciousURLs Scanner",
    riskScore: 0.89,
    detectedContent: "Visit http://malicious-site[.]com for more info",
    sanitizedContent: "[URL removed for security]",
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_98765",
      model: "gpt-4",
      urlReputation: "malicious",
      threatCategory: "phishing",
    },
  },
  {
    id: "SEC-006",
    timestamp: "2025-10-14T23:45:18Z",
    type: "SECRETS_EXPOSURE",
    severity: "CRITICAL",
    status: "OPEN",
    title: "API Key Exposed in Training Data",
    description:
      "Model output inadvertently revealed what appears to be an API key from training data.",
    traceId: "trace_9n0o1p2q3r4s5t6u",
    scanner: "Secrets Scanner",
    riskScore: 0.98,
    detectedContent: "API_KEY: sk_live_*********************",
    sanitizedContent: "API_KEY: [REDACTED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_11223",
      model: "gpt-3.5-turbo",
      secretType: "api_key",
      provider: "stripe",
    },
  },
  {
    id: "SEC-007",
    timestamp: "2025-10-14T22:15:42Z",
    type: "BIAS_DETECTION",
    severity: "MEDIUM",
    status: "IN_REVIEW",
    title: "Gender Bias Detected in Model Response",
    description:
      "Model output showed statistically significant gender bias in job role recommendations.",
    traceId: "trace_7v8w9x0y1z2a3b4c",
    scanner: "Bias Scanner",
    riskScore: 0.71,
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_33445",
      model: "gpt-4",
      biasType: "gender",
      biasScore: 0.78,
    },
  },
  {
    id: "SEC-008",
    timestamp: "2025-10-14T20:50:33Z",
    type: "SENSITIVE_INFO",
    severity: "HIGH",
    status: "OPEN",
    title: "Medical Information Detected",
    description:
      "Input contained protected health information (PHI) that requires special handling under HIPAA.",
    traceId: "trace_5d6e7f8g9h0i1j2k",
    scanner: "Sensitive Scanner",
    riskScore: 0.84,
    detectedContent: "Patient diagnosis: [MEDICAL CONDITION REDACTED]",
    sanitizedContent: "Patient diagnosis: [PROTECTED HEALTH INFORMATION]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_55667",
      model: "gpt-4",
      infoType: "medical_diagnosis",
      complianceFramework: "HIPAA",
    },
  },
  {
    id: "SEC-009",
    timestamp: "2025-10-14T19:30:15Z",
    type: "PII_DETECTION",
    severity: "HIGH",
    status: "RESOLVED",
    title: "Email Address and Phone Number Detected",
    description: "User shared personal contact information that was successfully anonymized.",
    traceId: "trace_3l4m5n6o7p8q9r0s",
    scanner: "Anonymize Scanner",
    riskScore: 0.76,
    detectedContent: "Contact me at john.doe@email.com or 555-123-4567",
    sanitizedContent: "Contact me at [EMAIL_1] or [PHONE_1]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_77889",
      model: "gpt-3.5-turbo",
      piiTypes: ["email", "phone"],
    },
  },
  {
    id: "SEC-010",
    timestamp: "2025-10-14T18:10:55Z",
    type: "PROMPT_INJECTION",
    severity: "MEDIUM",
    status: "FALSE_POSITIVE",
    title: "Potential Jailbreak Attempt",
    description:
      "Input pattern matched jailbreak signatures but was determined to be legitimate code discussion.",
    traceId: "trace_1t2u3v4w5x6y7z8a",
    scanner: "PromptInjection Scanner",
    riskScore: 0.62,
    detectedContent: "How do I break out of a loop in Python?",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_99001",
      model: "gpt-4",
      falsePositiveReason: "legitimate_coding_question",
    },
  },
  {
    id: "SEC-011",
    timestamp: "2025-10-14T17:45:30Z",
    type: "PII_DETECTION",
    severity: "CRITICAL",
    status: "OPEN",
    title: "Multiple Credit Card Numbers Detected",
    description:
      "User input contained multiple credit card numbers with CVV codes that were not properly masked.",
    traceId: "trace_4b5c6d7e8f9g0h1i",
    scanner: "Secrets Scanner",
    riskScore: 0.97,
    detectedContent: "Card 1: ****-****-****-1234, CVV: *** | Card 2: ****-****-****-5678",
    sanitizedContent: "Card information: [REDACTED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_44556",
      model: "gpt-4",
      pattern: "CREDIT_CARD",
      piiTypes: ["credit_card", "payment_info"],
    },
  },
  {
    id: "SEC-012",
    timestamp: "2025-10-14T17:20:15Z",
    type: "PII_DETECTION",
    severity: "HIGH",
    status: "OPEN",
    title: "Driver's License Number Exposed",
    description:
      "Model response included a driver's license number along with personal identification details.",
    traceId: "trace_2j3k4l5m6n7o8p9q",
    scanner: "Anonymize Scanner",
    riskScore: 0.88,
    detectedContent: "DL: D1234567, Name: John Smith, DOB: [REDACTED]",
    sanitizedContent: "DL: [REDACTED], Name: [REDACTED], DOB: [REDACTED]",
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_66778",
      model: "gpt-3.5-turbo",
      pattern: "DRIVERS_LICENSE",
      piiTypes: ["drivers_license", "name", "dob"],
    },
  },
  {
    id: "SEC-013",
    timestamp: "2025-10-14T16:55:42Z",
    type: "SENSITIVE_INFO",
    severity: "CRITICAL",
    status: "OPEN",
    title: "Bank Account Information Detected",
    description:
      "User shared complete bank account details including routing number and account number.",
    traceId: "trace_8r9s0t1u2v3w4x5y",
    scanner: "Sensitive Scanner",
    riskScore: 0.96,
    detectedContent: "Bank: Wells Fargo, Routing: ***********, Account: ************",
    sanitizedContent: "Bank information: [REDACTED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_88990",
      model: "gpt-4",
      infoType: "bank_account",
      complianceFramework: "PCI_DSS",
    },
  },
  {
    id: "SEC-014",
    timestamp: "2025-10-14T16:30:28Z",
    type: "PII_DETECTION",
    severity: "HIGH",
    status: "IN_REVIEW",
    title: "Passport Number in Customer Query",
    description:
      "Customer input contained a passport number that requires special handling under data protection laws.",
    traceId: "trace_6z7a8b9c0d1e2f3g",
    scanner: "Anonymize Scanner",
    riskScore: 0.85,
    detectedContent: "Passport: A12345678, issued by US State Department",
    sanitizedContent: "Passport: [REDACTED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_10203",
      model: "gpt-4",
      pattern: "PASSPORT",
      piiTypes: ["passport"],
    },
  },
  {
    id: "SEC-015",
    timestamp: "2025-10-14T16:05:10Z",
    type: "SENSITIVE_INFO",
    severity: "HIGH",
    status: "OPEN",
    title: "Insurance Policy Number and Health Data",
    description:
      "Input contained insurance policy numbers along with protected health information.",
    traceId: "trace_4h5i6j7k8l9m0n1o",
    scanner: "Sensitive Scanner",
    riskScore: 0.89,
    detectedContent: "Policy: HLT-9876543, Condition: [MEDICAL INFO REDACTED]",
    sanitizedContent: "Policy: [REDACTED], Condition: [PHI]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_30405",
      model: "gpt-3.5-turbo",
      infoType: "health_insurance",
      complianceFramework: "HIPAA",
    },
  },
  {
    id: "SEC-016",
    timestamp: "2025-10-14T15:40:55Z",
    type: "PII_DETECTION",
    severity: "MEDIUM",
    status: "RESOLVED",
    title: "Home Address Shared in Conversation",
    description:
      "User provided complete home address which was successfully anonymized before processing.",
    traceId: "trace_2p3q4r5s6t7u8v9w",
    scanner: "Anonymize Scanner",
    riskScore: 0.72,
    detectedContent: "I live at 123 Main Street, Apt 4B, New York, NY 10001",
    sanitizedContent: "I live at [ADDRESS_1]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_50607",
      model: "gpt-4",
      piiTypes: ["address"],
    },
  },
  {
    id: "SEC-017",
    timestamp: "2025-10-14T15:15:22Z",
    type: "PII_DETECTION",
    severity: "CRITICAL",
    status: "OPEN",
    title: "Tax ID Number (EIN) Detected",
    description:
      "Business conversation inadvertently exposed an Employer Identification Number (EIN).",
    traceId: "trace_0x1y2z3a4b5c6d7e8",
    scanner: "Secrets Scanner",
    riskScore: 0.93,
    detectedContent: "Company EIN: **-*******",
    sanitizedContent: "Company EIN: [REDACTED]",
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_70809",
      model: "gpt-4",
      pattern: "TAX_ID",
      piiTypes: ["tax_id", "ein"],
    },
  },
  {
    id: "SEC-018",
    timestamp: "2025-10-14T14:50:45Z",
    type: "SENSITIVE_INFO",
    severity: "HIGH",
    status: "OPEN",
    title: "Biometric Data Reference Detected",
    description:
      "Input contained references to biometric identification data which requires special protection.",
    traceId: "trace_8f9g0h1i2j3k4l5m",
    scanner: "Sensitive Scanner",
    riskScore: 0.87,
    detectedContent: "Fingerprint ID: [REDACTED], Face recognition match: confirmed",
    sanitizedContent: "Biometric data: [PROTECTED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_91011",
      model: "gpt-4",
      infoType: "biometric",
      complianceFramework: "GDPR",
    },
  },
  {
    id: "SEC-019",
    timestamp: "2025-10-14T14:25:30Z",
    type: "PII_DETECTION",
    severity: "HIGH",
    status: "IN_REVIEW",
    title: "Employee ID and Salary Information",
    description:
      "HR-related query exposed employee identification numbers and compensation details.",
    traceId: "trace_6n7o8p9q0r1s2t3u",
    scanner: "Anonymize Scanner",
    riskScore: 0.82,
    detectedContent: "Employee #E-12345, Salary: $[REDACTED]/year",
    sanitizedContent: "Employee [REDACTED], Salary: [REDACTED]",
    metadata: {
      endpoint: "/api/v1/completion",
      userId: "user_12131",
      model: "gpt-3.5-turbo",
      piiTypes: ["employee_id", "salary"],
    },
  },
  {
    id: "SEC-020",
    timestamp: "2025-10-14T14:00:15Z",
    type: "PII_DETECTION",
    severity: "MEDIUM",
    status: "RESOLVED",
    title: "IP Address and Geolocation Data",
    description:
      "System logs captured IP address and precise geolocation data that was subsequently anonymized.",
    traceId: "trace_4v5w6x7y8z9a0b1c",
    scanner: "Anonymize Scanner",
    riskScore: 0.68,
    detectedContent: "IP: 192.168.*.***, Location: [LAT/LONG REDACTED]",
    sanitizedContent: "Network data: [ANONYMIZED]",
    metadata: {
      endpoint: "/api/v1/chat",
      userId: "user_14151",
      model: "gpt-4",
      piiTypes: ["ip_address", "geolocation"],
    },
  },
];

// TODO: Replace with useDashboardStats() hook
export const mockDashboardStats: SecurityDashboardStats = {
  totalIssues: 127,
  criticalIssues: 8,
  openIssues: 45,
  resolvedToday: 12,
  averageRiskScore: 0.73,
};

// TODO: Replace with useChartMetadata() hook
export const mockChartMetadata: ChartMetadata = {
  month: "October",
  year: 2025,
  monthYear: "October 2025",
};

// TODO: Replace with useMonthlyChartData() hook
// Generate 15 days of mock data (up to October 15th, 2025)
export const mockMonthlyChartData: ChartDataPoint[] = Array.from({ length: 15 }, (_, i) => {
  const day = i + 1;
  return {
    day,
    date: `Oct ${day}, 2025`,
    criticalCount: Math.floor(Math.random() * 15) + 10, // 10-25 critical issues per day
    criticalIssues: [
      { type: "SSN Detection", count: Math.floor(Math.random() * 5) + 2 },
      { type: "API Key Exposure", count: Math.floor(Math.random() * 4) + 1 },
      { type: "Credit Card Info", count: Math.floor(Math.random() * 3) + 1 },
      { type: "Password Leak", count: Math.floor(Math.random() * 4) + 2 },
      { type: "Private Key Found", count: Math.floor(Math.random() * 3) + 1 },
    ],
    highCount: Math.floor(Math.random() * 25) + 15, // 15-40 high issues per day
    highIssues: [
      { type: "Prompt Injection", count: Math.floor(Math.random() * 8) + 3 },
      { type: "Malicious URL", count: Math.floor(Math.random() * 6) + 2 },
      { type: "Data Exfiltration", count: Math.floor(Math.random() * 5) + 2 },
      { type: "Jailbreak Attempt", count: Math.floor(Math.random() * 7) + 3 },
      { type: "SQL Injection", count: Math.floor(Math.random() * 4) + 2 },
    ],
  };
});

// TODO: Replace with useSeverityStats() hook
export const mockSeverityStats: Record<string, SeverityStats> = {
  critical: {
    count: 248,
    trend: "up",
    trendPercentage: 10,
    openCount: 221,
  },
  high: {
    count: 602,
    trend: "up",
    trendPercentage: 6,
    openCount: 542,
  },
  medium: {
    count: 2482,
    trend: "down",
    trendPercentage: 3,
    openCount: 1890,
  },
  low: {
    count: 2535,
    trend: "up",
    trendPercentage: 2,
    openCount: 1012,
  },
};

// TODO: Replace with useStatusTrendData() hook
export const mockStatusTrendData: StatusTrendDataPoint[] = Array.from({ length: 15 }, (_, i) => {
  const day = i + 1;
  // Simulate realistic patterns: more issues opened early in the period, resolution catching up
  const baseOpened = 25 + Math.floor(Math.random() * 20); // 25-45 opened per day
  const baseResolved = 15 + Math.floor(Math.random() * 25); // 15-40 resolved per day
  const inReview = 5 + Math.floor(Math.random() * 15); // 5-20 in review per day

  return {
    day,
    date: `Oct ${day}, 2025`,
    opened: baseOpened,
    resolved: baseResolved,
    inReview: inReview,
  };
});

// NOTE: Agents are now fetched via useAIAgents() hook from the real API
// This mock data is kept for reference only
import type { Agent } from "../types/security";
export const mockAgents: Agent[] = [
  {
    id: 1,
    name: "pii-aware-assistant",
    description:
      "AI assistant specialized in handling personally identifiable information with privacy controls",
    modelName: "gemini-2.0-flash-exp",
    traceSource: "logfire_pydantic_ai",
    otelScopeName: "pydantic-ai",
    modelProvider: "google",
    criticalIssues: 3,
    highIssues: 2,
    totalIssues: 8,
    traceCount: 150,
    trendPercentage: 12,
    trendDirection: "up",
    firstSeenAt: "2025-01-01T00:00:00Z",
    lastSeenAt: "2025-01-27T12:00:00Z",
  },
  {
    id: 2,
    name: "prompt-injection-guard",
    description: "Security-focused agent that detects and prevents prompt injection attacks",
    modelName: "gpt-4",
    traceSource: "logfire_openai",
    otelScopeName: "logfire.openai",
    modelProvider: "openai",
    criticalIssues: 1,
    highIssues: 3,
    totalIssues: 6,
    traceCount: 89,
    trendPercentage: 5,
    trendDirection: "down",
    firstSeenAt: "2025-01-05T00:00:00Z",
    lastSeenAt: "2025-01-27T11:30:00Z",
  },
  {
    id: 3,
    name: "content-moderator",
    description:
      "Monitors and filters toxic content and inappropriate language in user interactions",
    modelName: "claude-3-sonnet",
    traceSource: "logfire_anthropic",
    otelScopeName: "logfire.anthropic",
    modelProvider: "anthropic",
    criticalIssues: 0,
    highIssues: 1,
    totalIssues: 4,
    traceCount: 67,
    trendPercentage: 8,
    trendDirection: "down",
    firstSeenAt: "2025-01-10T00:00:00Z",
    lastSeenAt: "2025-01-27T10:45:00Z",
  },
  {
    id: 4,
    name: "data-exfiltration-detector",
    description:
      "Identifies and blocks attempts to extract sensitive database and system information",
    modelName: "gemini-2.0-flash-exp",
    traceSource: "logfire_pydantic_ai",
    otelScopeName: "pydantic-ai",
    modelProvider: "google",
    criticalIssues: 2,
    highIssues: 1,
    totalIssues: 5,
    traceCount: 42,
    trendPercentage: 15,
    trendDirection: "up",
    firstSeenAt: "2025-01-15T00:00:00Z",
    lastSeenAt: "2025-01-27T09:15:00Z",
  },
  {
    id: 5,
    name: "url-safety-scanner",
    description: "Scans and validates URLs to prevent phishing and malicious link distribution",
    modelName: "gpt-3.5-turbo",
    traceSource: "logfire_openai",
    otelScopeName: "logfire.openai",
    modelProvider: "openai",
    criticalIssues: 0,
    highIssues: 2,
    totalIssues: 3,
    traceCount: 28,
    trendPercentage: 3,
    trendDirection: "up",
    firstSeenAt: "2025-01-20T00:00:00Z",
    lastSeenAt: "2025-01-27T08:00:00Z",
  },
];

// TODO: Replace with useComplianceScores() hook
export const mockComplianceScores: ComplianceScore[] = [
  {
    id: "iso-42001",
    name: "ISO 42001 - AI Management System",
    shortName: "ISO 42001",
    score: 78,
    category: "management",
    description:
      "AI Management System certification covering governance, risk management, and operational controls for AI systems",
    details: {
      status: "compliant",
      controls: 39,
      totalControls: 50,
      pending: 11,
      criticalGaps: 3,
      highGaps: 5,
      trend: "improving",
      trendPercentage: "+5%",
      nextDeadline: "2025-12-31",
      estimatedCost: "$28k",
      responsibleTeam: "AI Governance Team",
      documentationGaps: 7,
      lastAudit: "2025-10-01",
      nextReview: "2025-11-01",
      relatedIssues: {
        critical: 2,
        high: 5,
      },
      priorityActions: [
        {
          id: "iso-action-1",
          title: "Implement AI Model Risk Assessment Framework",
          priority: "critical",
          dueInDays: 14,
          description: "Critical for compliance",
        },
        {
          id: "iso-action-2",
          title: "Complete Data Governance Documentation",
          priority: "high",
          dueInDays: 30,
          description: "High priority",
        },
        {
          id: "iso-action-3",
          title: "Establish AI Ethics Review Board",
          priority: "high",
          dueInDays: 45,
          description: "High priority",
        },
      ],
    },
  },
  {
    id: "nist-ai-rmf",
    name: "NIST AI Risk Management Framework",
    shortName: "NIST AI RMF",
    score: 85,
    category: "risk",
    description:
      "Framework for managing AI risks including trustworthiness, accountability, and transparency",
    details: {
      status: "compliant",
      controls: 42,
      totalControls: 50,
      pending: 8,
      criticalGaps: 2,
      highGaps: 3,
      trend: "improving",
      trendPercentage: "+8%",
      nextDeadline: "2025-12-15",
      estimatedCost: "$20k",
      responsibleTeam: "Risk Management Team",
      documentationGaps: 5,
      lastAudit: "2025-09-15",
      nextReview: "2025-10-30",
      relatedIssues: {
        critical: 1,
        high: 4,
      },
      priorityActions: [
        {
          id: "nist-action-1",
          title: "Complete Trustworthiness Assessment",
          priority: "critical",
          dueInDays: 10,
          description: "Critical for NIST compliance",
        },
        {
          id: "nist-action-2",
          title: "Update Risk Register for AI Systems",
          priority: "high",
          dueInDays: 25,
          description: "High priority",
        },
        {
          id: "nist-action-3",
          title: "Implement Continuous Monitoring",
          priority: "high",
          dueInDays: 40,
          description: "High priority",
        },
      ],
    },
  },
  {
    id: "eu-ai-act",
    name: "EU AI Act Compliance",
    shortName: "EU AI Act",
    score: 72,
    category: "regulation",
    description:
      "European Union AI regulation compliance covering high-risk AI systems and prohibited practices",
    details: {
      status: "partial",
      controls: 36,
      totalControls: 50,
      pending: 14,
      criticalGaps: 4,
      highGaps: 6,
      trend: "stable",
      trendPercentage: "+2%",
      nextDeadline: "2026-08-02",
      estimatedCost: "$35k",
      responsibleTeam: "Legal & Compliance Team",
      documentationGaps: 8,
      lastAudit: "2025-09-20",
      nextReview: "2025-11-15",
      relatedIssues: {
        critical: 3,
        high: 6,
      },
      priorityActions: [
        {
          id: "eu-action-1",
          title: "Classify AI Systems by Risk Level",
          priority: "critical",
          dueInDays: 20,
          description: "Critical for EU AI Act",
        },
        {
          id: "eu-action-2",
          title: "Implement Conformity Assessment",
          priority: "critical",
          dueInDays: 35,
          description: "Critical for compliance",
        },
        {
          id: "eu-action-3",
          title: "Establish CE Marking Process",
          priority: "high",
          dueInDays: 60,
          description: "High priority",
        },
      ],
    },
  },
  {
    id: "ieee-7000",
    name: "IEEE 7000 Series - AI Ethics",
    shortName: "IEEE 7000",
    score: 91,
    category: "ethics",
    description:
      "Ethical standards for AI systems including fairness, transparency, and human-centric design",
    details: {
      status: "compliant",
      controls: 45,
      totalControls: 50,
      pending: 5,
      criticalGaps: 1,
      highGaps: 2,
      trend: "improving",
      trendPercentage: "+6%",
      nextDeadline: "2026-01-31",
      estimatedCost: "$12k",
      responsibleTeam: "AI Ethics Committee",
      documentationGaps: 3,
      lastAudit: "2025-10-05",
      nextReview: "2025-11-20",
      relatedIssues: {
        critical: 0,
        high: 2,
      },
      priorityActions: [
        {
          id: "ieee-action-1",
          title: "Complete Bias Assessment for Models",
          priority: "high",
          dueInDays: 15,
          description: "High priority",
        },
        {
          id: "ieee-action-2",
          title: "Update Transparency Documentation",
          priority: "high",
          dueInDays: 28,
          description: "High priority",
        },
        {
          id: "ieee-action-3",
          title: "Review Human-AI Interaction Guidelines",
          priority: "medium",
          dueInDays: 50,
          description: "Medium priority",
        },
      ],
    },
  },
  {
    id: "soc2-ai",
    name: "SOC 2 Type II - AI Systems",
    shortName: "SOC 2 AI",
    score: 88,
    category: "management",
    description:
      "Service Organization Control certification for AI system security, availability, and confidentiality",
    details: {
      status: "compliant",
      controls: 44,
      totalControls: 50,
      pending: 6,
      criticalGaps: 1,
      highGaps: 3,
      trend: "improving",
      trendPercentage: "+7%",
      nextDeadline: "2025-11-30",
      estimatedCost: "$15k",
      responsibleTeam: "InfoSec Team",
      documentationGaps: 4,
      lastAudit: "2025-09-25",
      nextReview: "2025-10-25",
      relatedIssues: {
        critical: 1,
        high: 3,
      },
      priorityActions: [
        {
          id: "soc2-action-1",
          title: "Complete Security Controls Testing",
          priority: "critical",
          dueInDays: 12,
          description: "Critical for audit",
        },
        {
          id: "soc2-action-2",
          title: "Update Availability Monitoring",
          priority: "high",
          dueInDays: 22,
          description: "High priority",
        },
        {
          id: "soc2-action-3",
          title: "Review Access Control Policies",
          priority: "high",
          dueInDays: 35,
          description: "High priority",
        },
      ],
    },
  },
  {
    id: "gdpr-ai",
    name: "GDPR AI Data Protection",
    shortName: "GDPR AI",
    score: 94,
    category: "regulation",
    description:
      "General Data Protection Regulation compliance for AI systems handling personal data",
    details: {
      status: "compliant",
      controls: 47,
      totalControls: 50,
      pending: 3,
      criticalGaps: 0,
      highGaps: 1,
      trend: "improving",
      trendPercentage: "+4%",
      nextDeadline: "2026-05-25",
      estimatedCost: "$8k",
      responsibleTeam: "Data Protection Office",
      documentationGaps: 2,
      lastAudit: "2025-10-10",
      nextReview: "2025-12-10",
      relatedIssues: {
        critical: 0,
        high: 1,
      },
      priorityActions: [
        {
          id: "gdpr-action-1",
          title: "Update Data Processing Records",
          priority: "high",
          dueInDays: 18,
          description: "High priority",
        },
        {
          id: "gdpr-action-2",
          title: "Review Data Subject Rights Procedures",
          priority: "medium",
          dueInDays: 40,
          description: "Medium priority",
        },
        {
          id: "gdpr-action-3",
          title: "Complete Privacy Impact Assessments",
          priority: "medium",
          dueInDays: 55,
          description: "Medium priority",
        },
      ],
    },
  },
];

// Issue Severity Statistics
export const mockIssueSeverityData = {
  critical: mockSecurityIssues.filter((i) => i.severity === "CRITICAL").length,
  high: mockSecurityIssues.filter((i) => i.severity === "HIGH").length,
  medium: mockSecurityIssues.filter((i) => i.severity === "MEDIUM").length,
  low: mockSecurityIssues.filter((i) => i.severity === "LOW").length,
  criticalTrend: 19,
  highTrend: 0,
  mediumTrend: 0,
  lowTrend: 0,
};

// Open Issue Age Statistics
export const mockOpenIssueAgeData = (() => {
  const openIssues = mockSecurityIssues.filter((i) => i.status === "OPEN");

  // Calculate average age (mock calculation - in real app, calculate from timestamp)
  const averageAge = 12; // days

  // Age distribution
  const age0to7 = Math.round(openIssues.length * 0.3);
  const age8to30 = Math.round(openIssues.length * 0.5);
  const age30plus = Math.round(openIssues.length * 0.2);

  const total = age0to7 + age8to30 + age30plus;

  return {
    averageAge,
    ageDistribution: [
      {
        label: "0-7 days",
        count: age0to7,
        percentage: (age0to7 / total) * 100,
        color: "bg-green-500",
      },
      {
        label: "8-30 days",
        count: age8to30,
        percentage: (age8to30 / total) * 100,
        color: "bg-yellow-500",
      },
      {
        label: "30+ days",
        count: age30plus,
        percentage: (age30plus / total) * 100,
        color: "bg-red-500",
      },
    ],
  };
})();
